/**
 * Error reporting. Sentry is loaded only when VITE_SENTRY_DSN is set, so local dev and
 * tests have no dependency on it.
 */
import { env } from './env';

type Reporter = (error: unknown, context?: Record<string, unknown>) => void;
let reporter: Reporter = (error, context) => console.error(error, context);

export async function initMonitoring() {
  if (!env.sentryDsn) return;
  const Sentry = await import('@sentry/react');
  Sentry.init({
    dsn: env.sentryDsn,
    environment: import.meta.env.MODE,
    release: env.release,
    tracesSampleRate: 0.1,
  });
  reporter = (error, context) => Sentry.captureException(error, { extra: context });
}

export function reportError(error: unknown, context?: Record<string, unknown>) {
  reporter(error, context);
}
